import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { SignIn, SignUp, useAuth } from '@clerk/clerk-react'
import { useNavigate } from 'react-router-dom';
import '../../../../assets/stylesheets/clerk.css'

const pageAfterSignIn = '/gallery'

/**
 * Right Panel component for authentication screen
 *
 * Contains the Clerk SignIn or SignUp component with custom
 * form fields configuration and UI components.
 */
const RightPanel = () => {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();

  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode');

  // navigate to the gallery if signed in
  React.useEffect(() => {
    if (isSignedIn) {
      navigate(pageAfterSignIn);
    }
  }, [isSignedIn, navigate]);

  if (isSignedIn) {
    return null;
  }

  // keep this on for now; we can hide it with a paid Clerk plan,
  // but then we'd lose the Clerk-managed links that let us
  // swap between sign-in and sign-up modes
  const displayClerkFooter = true

  return (
    <div className="right-panel">
      {!(mode === 'signup') ?
        <SignIn
          appearance={{
            elements: {
              footer: {
                display: displayClerkFooter ? 'true' : 'none',
              },
            },
          }}
          signUpUrl="/auth?mode=signup"
          forceRedirectUrl={pageAfterSignIn}
          fallbackRedirectUrl={pageAfterSignIn}
          signUpFallbackRedirectUrl={pageAfterSignIn}
          signUpForceRedirectUrl={pageAfterSignIn} /> :
        <SignUp
          appearance={{
            elements: {
              footer: {
                display: displayClerkFooter ? 'true' : 'none',
              },
            },
          }}
          signInUrl="/auth?mode=signin"
       />}
    </div>
  )
}

export default RightPanel
